/**
 * Onboarding progress persistence (P2.1-S6).
 *
 * localStorage key: `aiagent.onboarding.v1`
 * Shape: { welcome_seen: boolean, version: number }
 *
 * version bump khi flow thay đổi → user thấy lại welcome.
 */

const STORAGE_KEY = "aiagent.onboarding.v1";
const CURRENT_VERSION = 1;

interface OnboardingState {
  welcome_seen: boolean;
  version: number;
}

function read(): OnboardingState {
  if (typeof window === "undefined") {
    return { welcome_seen: false, version: CURRENT_VERSION };
  }
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return { welcome_seen: false, version: CURRENT_VERSION };
    const parsed = JSON.parse(raw) as Partial<OnboardingState>;
    if (parsed.version !== CURRENT_VERSION) {
      return { welcome_seen: false, version: CURRENT_VERSION };
    }
    return {
      welcome_seen: Boolean(parsed.welcome_seen),
      version: CURRENT_VERSION,
    };
  } catch {
    return { welcome_seen: false, version: CURRENT_VERSION };
  }
}

function write(state: OnboardingState): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // ignore quota errors
  }
}

export function isFirstTime(): boolean {
  return !read().welcome_seen;
}

export function markWelcomeSeen(): void {
  write({ welcome_seen: true, version: CURRENT_VERSION });
}

/** Reset — debug helper, gọi từ console khi cần test lại flow. */
export function resetOnboarding(): void {
  if (typeof window !== "undefined") {
    window.localStorage.removeItem(STORAGE_KEY);
  }
}
